export default "__VITE_ASSET__B393yvwO__"